export const util = {
    showRightImg(url) {
        if(url.includes('http') || url.includes('https')) {
          return url
        } else {
          console.log('23232, https://' + url);
          return 'https://' + url
        }
    },
    decode(content) {
      if(content) {
        const key = CryptoJS.enc.Utf8.parse('xiaohei202201071');
        let decrypt = CryptoJS.AES.decrypt(content, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        });
        let testDecryptStr = CryptoJS.enc.Utf8.stringify(decrypt).toString();
        return testDecryptStr
      }
      return '';
    },
    encrypt(content) {
      if(content) {
        const key = CryptoJS.enc.Utf8.parse('xiaohei202201071');
        let encrypt = CryptoJS.AES.encrypt(content, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        });
        console.log(encrypt);
        let testDecryptStr = CryptoJS.enc.Base64.stringify(encrypt.ciphertext);
        return testDecryptStr
      }
      return '';
    }
}

